import { atMapsToGeojson } from '../sources/at_maps';
import { addPolylines, removePolylines } from './polylines';
import { addChevrons, removeChevrons } from './chevrons';
import { addStartEnd, removeStartEnd } from './start_end';
import { addMapWaypoints, removeWaypoints } from './waypoints';
import { addPhotos, removePhotos } from './photos';
import { addCurrLocMarker, removeCurrLocMarker } from './current_location';
import { updateLayerProperty } from '../layers/layer_helpers';

const atMapId = 'atMap';

const addAtMap = ({ map, atMap, renderWaypointPopup, handlePhotoClick, bounds, withWaypointLabels = true, messagingChannel, polylineOpts }) => {
  if (!atMap) return;

  const atMapGeojson = atMapsToGeojson([atMap]);
  const multiCoordinates = atMapGeojson.features.map(atMapFeature => {
    const coords = atMapFeature.geometry.coordinates.flat();
    if (bounds) {
      coords.forEach(lngLat => bounds.extend(lngLat));
    }
    return coords;
  });

  const { waypoints, mapPhotos } = atMap;
  const photos = mapPhotos?.map(mapPhoto => mapPhoto.photo) ?? [];

  // Add all sources/layers
  addPolylines(map, `${atMapId}-polylines`, atMapGeojson, polylineOpts);
  addChevrons(map, `${atMapId}-chevrons`, `${atMapId}-polylines`);
  addStartEnd(map, `${atMapId}-start-end`, multiCoordinates);
  addCurrLocMarker(map);
  addMapWaypoints(map, `${atMapId}-waypoints`, waypoints, renderWaypointPopup, bounds, messagingChannel, atMap.editWaypointId, withWaypointLabels);
  addPhotos(map, `${atMapId}-photos`, photos, handlePhotoClick, bounds);
};

const removeAtMap = map => {
  removePhotos(map, `${atMapId}-photos`);
  removeWaypoints(map, `${atMapId}-waypoints`);
  removeCurrLocMarker(map);
  removeStartEnd(map, `${atMapId}-start-end`);
  removeChevrons(map, `${atMapId}-chevrons`);
  removePolylines(map, `${atMapId}-polylines`);
};

const putAtMapIntoBackground = map => {
  updateLayerProperty(map, `${atMapId}-polylines`, 'paint', 'line-opacity', 0.4);
  updateLayerProperty(map, `${atMapId}-chevrons`, 'paint', 'icon-opacity', 0.8);
  updateLayerProperty(map, `${atMapId}-start-end`, 'layout', 'visibility', 'none');
};

const bringAtMapIntoForeground = map => {
  updateLayerProperty(map, `${atMapId}-polylines`, 'paint', 'line-opacity', 1);
  updateLayerProperty(map, `${atMapId}-chevrons`, 'paint', 'icon-opacity', 1);
  updateLayerProperty(map, `${atMapId}-start-end`, 'layout', 'visibility', 'visible');
};

export { addAtMap, removeAtMap, putAtMapIntoBackground, bringAtMapIntoForeground, atMapId };
